export {ApolloClient} from 'apollo-client'
export {BatchHttpLink} from 'apollo-link-batch-http'
export {HttpLink} from 'apollo-link-http'
export {InMemoryCache} from 'apollo-cache-inmemory'
export {withClientState} from 'apollo-link-state'
export {ApolloLink, split} from 'apollo-link'
export {WebSocketLink} from 'apollo-link-ws'
export {getMainDefinition} from 'apollo-utilities'
export {createNetworkStatusNotifier} from 'react-apollo-network-status'
export {BrowserRouter} from 'react-router-dom'
export {ApolloProvider, withApollo, Subscription, Query, QueryResult, Mutation} from 'react-apollo'

export function compose(...funcs) {
  if (funcs.length === 0) {
    return arg => arg
  }

  if (funcs.length === 1) {
    return funcs[0]
  }

  return funcs.reduce((a, b) => (...args) => a(b(...args)))
}




// WEBPACK FOOTER //
// ./src/shared/components/3rd-party/apollo.tsx